import React, { PureComponent } from 'react'
import { Select as AntSelect } from 'antd'
import classNames from 'classnames'
import './Select.less'

const { Option, OptGroup } = AntSelect
export default class Select extends PureComponent {
  render() {
    const { v2, className, ...others} = this.props
    const selectClassName = classNames(className, v2 ? 'pan-select-rounded' : 'pan-select')
    const selectProps = {
      className: selectClassName
    }
    return <AntSelect {...others} {...selectProps} />
  }
}

Select.Option = Option
Select.OptGroup = OptGroup
Select.AntSelect = AntSelect
